import {Component, EventEmitter, Input, Output, ViewChild, ElementRef, inject, OnInit} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css'],
    standalone: false
})
export class FileUploadComponent implements OnInit {
  @Input() accept: string = '';
  @Input() multiple: boolean = false;
  @Input() label: string = '';

  private translate: TranslateService = inject(TranslateService);
  selectedFileName: string = "";

  @Output() filesSelected = new EventEmitter<FileList>();

  @ViewChild('fileInput', { static: false }) fileInputRef: ElementRef<HTMLInputElement>;

  trigger(): void {
    if (this.fileInputRef && this.fileInputRef.nativeElement) {
      this.fileInputRef.nativeElement.click();
    }
  }

  ngOnInit() {
    this.selectedFileName = this.translate.instant('No file chosen');
  }


  onChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.filesSelected.emit(input.files as FileList);
    if (input) {
      this.selectedFileName = input.files.item(0).name;
      input.value = '';
    }
  }
}


